import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../local-storage/local-storage.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
    constructor(private localStorageService: LocalStorageService) { }
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        let tempReq: HttpRequest<any>;

        if (!request.headers.has('public')) {

            tempReq = request.clone({
               withCredentials: true
            })

        } else {
            tempReq = request.clone({
                headers: request.headers.delete('public'),
                withCredentials: true
            })
        }
        if (!tempReq.headers.has('Content-Type'))
            tempReq.headers.set('Content-Type', 'application/json');

        return next.handle(tempReq)
    }
}